
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppSettingsFriendlyIds from "../../../components/settings-default/FriendlyIds.vue";
import AppExtraNumberSettings from "../../../components/settings-default/ExtraNumberSettings.vue";

export default Vue.extend({
	data() {
		return {
			path: [{
				to: "/settings", value: this.$ct("general")
			},     {value: this.$ct("id-friendly")}] as IBreadCrumb[],
		};
	},
	components: {
		AppSettingsFriendlyIds,
		AppExtraNumberSettings
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
